import React from "react";
import { Routes, Route } from "react-router-dom";

// Layouts
import NonAuthLayout from "../Layouts/NonAuthLayout";
import VerticalLayout from "../Layouts/index";

// Routes
import { authProtectedRoutes, publicRoutes } from "./allRoutes";
import { AuthProtected } from "./AuthProtected";

const rotasPublicasSemLayout = [
  "/:nomeFeira/vendas/:idFeira",
  "/:nomeFeira/renovacao/:idFeira",
  "/:nomeFeira/rotas/:idFeira",

  "/vendas/:idFeira",
  "/renovacao/:idFeira",
  "/rotas/:idFeira",

  "/mapa-desativado",
  "/nao-encontrada",
];

const Index = () => {
  const ehRotaPublicaSemLayout = (path) => {
    return rotasPublicasSemLayout.includes(path);
  };

  return (
    <React.Fragment>
      <Routes>
        {publicRoutes.map((route, idx) => {
          const semLayout = ehRotaPublicaSemLayout(route.path);

          return (
            <Route
              path={route.path}
              element={
                semLayout ? (
                  route.component
                ) : (
                  <NonAuthLayout>{route.component}</NonAuthLayout>
                )
              }
              key={`public-${idx}`}
            />
          );
        })}

        {authProtectedRoutes.map((route, idx) => (
          <Route
            path={route.path}
            element={
              <AuthProtected>
                <VerticalLayout>{route.component}</VerticalLayout>
              </AuthProtected>
            }
            key={`auth-${idx}`}
          />
        ))}
      </Routes>
    </React.Fragment>
  );
};

export default Index;